export default {
  state: {
    // newRouter: [],
    locale: '',
    langImg: '',
    // account: '',
    // merchantId: '',
    // lastLoginIp: '',
    // lastLoginTime: '',
    // role: [],
    // roleBackend: '',
    token: ''
    // permissionFrontNameList: []
  },
  mutations: {
    // SET_NEW_ROUTER: (state, newRouter) => {
    //   state.newRouter = newRouter
    // },
    SET_LOGININFO: (state, data) => {
      Object.keys(data).forEach(key => {
        state[key] = data[key]
      })
    },
    SET_LANGUAGE: (state, locale) => {
      state.locale = locale
    },
    SET_LANGIMG: (state, img) => {
      state.langImg = img
    }
  },
  actions: {
    submitLogin ({ commit }, data) {
      // const permissionIdList = data.permissions.map(item => item.permissionId)
      const loginData = {
        // locale: sessionStorage.getItem('locale'),
        // account: data.account,
        // merchantId: data.merchant,
        // lastLoginIp: data.lastLoginIp,
        // lastLoginTime: data.lastLoginTime,
        // role: roleHandler(permissionIdList),
        // roleBackend: data.role,
        token: data.token
        // permissionFrontNameList: data.permissions.map(item => item.permissionFrontName).filter(Boolean)
      }
      localStorage.setItem('browserStorage', data.browserStorage)
      commit('SET_LOGININFO', loginData)
    },
    changeLanguage ({ commit }) {
      commit('SET_LANGUAGE', sessionStorage.getItem('locale'))
    },
    changeLangImg ({ commit }) {
      commit('SET_LANGIMG', sessionStorage.getItem('langImg'))
    },
    async Logout ({ commit }) {
      return new Promise((resolve, reject) => {
        const loginData = {
          // account: '',
          // merchantId: '',
          // lastLoginIp: '',
          // lastLoginTime: '',
          // role: [],
          // roleBackend: '',
          token: ''
          // permissionFrontNameList: []
        }
        commit('SET_LOGININFO', loginData)
        sessionStorage.clear()
        location.reload()
        resolve('logout')
      }).catch(error => {
        return Promise.reject(error)
      })
    }
    // addRoutes ({ commit }, newRouter) {
    //   commit('SET_NEW_ROUTER', newRouter)
    // }
  }
}

// const roleHandler = (permissionIdList) => {
//   const permissionIdListAfterSet = Array.from(new Set(permissionIdList.map(item => item.slice(0, 2))))
//   const role = []
//   const roleList = [
//     { mapping: 'agent', rawName: 'AG' },
//     { mapping: 'controlCenter', rawName: 'CC' },
//     { mapping: 'customerService', rawName: 'CS' },
//     { mapping: 'finance', rawName: 'F0' },
//     { mapping: 'client', rawName: 'M0' },
//     { mapping: 'staff', rawName: 'RL' }
//   ]
//   roleList.forEach(item => {
//     if (permissionIdListAfterSet.includes(item.rawName)) {
//       role.push(item.mapping)
//     }
//   })
//   return role
// }
